import Axios from 'axios';

export default {

  // 社区活动分页列表
  listPage(
    title,
    type,
    data_status,
    is_show,
    community_id,
    page,
    per_page
  ) {
    return Axios.get('/activity/api/admin/', {
      params: {
        title,
        type,
        data_status,
        is_show,
        community_id,
        page,
        per_page
      }
    });
  },

  // //活动详情
  // activeDetail(
  //   id,
  //   include,
  // ) {
  //   return Axios.get(`/activity/api/admin/${id}`, {
  //     params: {
  //       include,
  //     },
  //   });
  // },

  // //新增活动
  // addActive(
  //   title,
  //   start_time,
  //   end_time,
  //   banner,
  //   status,
  //   score,
  //   address,
  //   places,
  //   signup_end_time,
  //   content,
  //   community_ids,
  //   fields,
  // ) {
  //   return Axios.post('/activity/api/admin/',{
  //       title,
  //       start_time,
  //       end_time,
  //       banner,
  //       status,
  //       score,
  //       address,
  //       places,
  //       signup_end_time,
  //       content,
  //       community_ids,
  //       fields,
  //   });
  // },

  // //编辑活动
  // eidtActive(
  //   title,
  //   start_time,
  //   end_time,
  //   banner,
  //   status,
  //   score,
  //   address,
  //   places,
  //   signup_end_time,
  //   content,
  //   community_ids,
  //   fields,
  //   id,
  // ){
  //   return Axios.put(`/activity/api/admin/${id}`,{
  //     title,
  //     start_time,
  //     end_time,
  //     banner,
  //     status,
  //     score,
  //     address,
  //     places,
  //     signup_end_time,
  //     content,
  //     community_ids,
  //     fields,
  //   });
  // },

  // //删除活动
  // deteActive(
  //   ids,
  // ) {
  //   return Axios.delete('/activity/api/admin/',{
  //     data: {
  //       ids
  //     }
  //   });
  // },

  // //活动下线
  // publishActive(
  //   id,
  // ) {
  //   return Axios.put(`/activity/api/admin/${id}/publish`,{
  //   });
  // },

  // //活动下线
  // downActive(
  //   id,
  // ) {
  //   return Axios.put(`/activity/api/admin/${id}/disableorenable`,{
  //   });
  // },

  // //新增问卷
  // addQuestionnaire(
  //   title,
  //   start_time,
  //   ended_at,
  //   banner,
  //   community_ids,
  //   status,
  //   score,
  //   description,
  //   questions,

  // ){
  //   return Axios.post('/wjdc/api/admin/',{
  //     title,
  //     start_time,
  //     ended_at,
  //     banner,
  //     community_ids,
  //     status,
  //     score,
  //     description,
  //     questions,
  //   });
  // },

  // //问卷详情
  // questionDetail(
  //   id,
  //   include,
  // ) {
  //   return Axios.get(`/wjdc/api/admin/${id}`, {
  //     params: {
  //       include,
  //     },
  //   });
  // },

  // //问卷编辑
  // editQuestionnaire(
  //   title,
  //   start_time,
  //   ended_at,
  //   banner,
  //   community_ids,
  //   status,
  //   score,
  //   description,
  //   questions,
  //   id,
  // ){
  //   return Axios.put(`/wjdc/api/admin/${id}`,{
  //     title,
  //     start_time,
  //     ended_at,
  //     banner,
  //     community_ids,
  //     status,
  //     score,
  //     description,
  //     questions,
  //   });
  // },

  //   //删除问卷
  // deteQuestion(
  //   ids,
  // ) {
  //   return Axios.delete('/wjdc/api/admin/',{
  //     data: {
  //       ids
  //     }
  //   });
  // },

  // //问卷推送
  // publishQuestion(
  //   id,
  // ) {
  //   return Axios.put(`/wjdc/api/admin/${id}/status`,{
  //   });
  // },

  // //问卷下线
  // downQuestion(
  //   id,
  // ) {
  //   return Axios.put(`/wjdc/api/admin/${id}/show`,{
  //   });
  // },

  // // 报名列表
  // signuptitleList(
  //   include,
  //   id,
  // ) {
  //   return Axios.get(`/activity/api/admin/${id}`, {
  //     params:{
  //       include
  //     }
  //   });
  // },

  // signupList(
  //   name,
  //   status,
  //   id,
  // ) {
  //   return Axios.get(`/activity/api/admin/${id}/signupusers`, {
  //     params: {
  //       name,
  //       status,
  //     },

  //   });
  // },

  // // 问卷列表
  // questiontitleList(
  //   name,
  //   status,
  //   id,
  // ) {
  //   return Axios.get(`/wjdc/api/admin/${id}/questions`, {
  //     params: {
  //       name,
  //       status,
  //     },

  //   });
  // },

  // questionList(
  //   name,
  //   status,
  //   id,
  // ) {
  //   return Axios.get(`/wjdc/api/admin/${id}/answer`, {
  //     params: {
  //       name,
  //       status,
  //     },

  //   });
  // },  

  // // 问卷数据统计
  // datatotal(
  //   id,
  // ) {
  //   return Axios.get(`/wjdc/api/admin/${id}/statistical`, {});
  // },

}